import { NgModule } from '@angular/core';
import { AnonymousConsentsModule, AuthModule, CostCenterOccModule, ExternalRoutesModule, ProductModule, ProductOccModule, provideFeatureToggles, UserModule, UserOccModule } from "@spartacus/core";
import { AnonymousConsentManagementBannerModule, AnonymousConsentsDialogModule, BannerCarouselModule, BannerModule, BreadcrumbModule, CategoryNavigationModule, CmsParagraphModule, ConsentManagementModule, FooterNavigationModule, HamburgerMenuModule, HomePageEventModule, LinkModule, LoginRouteModule, LogoutModule, MyAccountV2Module, MyCouponsModule, MyInterestsModule, NavigationEventModule, NavigationModule, NotificationPreferenceModule, PageTitleModule, PaymentMethodsModule, PDFModule, ProductCarouselModule, ProductDetailsPageModule, ProductFacetNavigationModule, ProductImagesModule, ProductIntroModule, ProductListingPageModule, ProductListModule, ProductPageEventModule, ProductReferencesModule, ProductSummaryModule, ProductTabsModule, ScrollToTopModule, SearchBoxModule, SiteContextSelectorModule, SiteThemeSwitcherModule, StockNotificationModule, TabParagraphContainerModule, VideoModule } from "@spartacus/storefront";
import { UserFeatureModule } from './features/user/user-feature.module';
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module';
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module';
import { CartImportExportFeatureModule } from './features/cart/cart-import-export-feature.module';
import { OrderFeatureModule } from './features/order/order-feature.module';
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module';
import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { TagManagementFeatureModule } from './features/tracking/tag-management-feature.module';
import { CustomerTicketingFeatureModule } from './features/customer-ticketing/customer-ticketing-feature.module';
import { OrganizationUserRegistrationFeatureModule } from './features/organization/organization-user-registration-feature.module';
import { OrganizationAdministrationFeatureModule } from './features/organization/organization-administration-feature.module';
import { OrganizationAccountSummaryFeatureModule } from './features/organization/organization-account-summary-feature.module';
import { OrganizationUnitOrderFeatureModule } from './features/organization/organization-unit-order-feature.module';
import { OrganizationOrderApprovalFeatureModule } from './features/organization/organization-order-approval-feature.module';
import { StoreFinderFeatureModule } from './features/storefinder/store-finder-feature.module';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { AsmCustomer360FeatureModule } from './features/asm/asm-customer360-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { ProductMultiDimensionalSelectorFeatureModule } from './features/product-multi-dimensional/product-multi-dimensional-selector-feature.module';
import { ProductVariantsFeatureModule } from './features/product/product-variants-feature.module';
import { ProductImageZoomFeatureModule } from './features/product/product-image-zoom-feature.module';
import { QuoteFeatureModule } from './features/quote/quote-feature.module';
import { GonvarriQuickOrderModule } from '../modules/gonvarri-quick-order/gonvarri-quick-order.module';

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    ScrollToTopModule,
    PageTitleModule,
    VideoModule,
    PDFModule,
    SiteThemeSwitcherModule,
    UserModule,
    UserOccModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    MyAccountV2Module,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    AnonymousConsentsModule.forRoot(),
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    CartBaseFeatureModule,
    CartSavedCartFeatureModule,
    CartQuickOrderFeatureModule,
    CartImportExportFeatureModule,
    OrderFeatureModule,
    CheckoutFeatureModule,
    PersonalizationFeatureModule,
    TagManagementFeatureModule,
    CustomerTicketingFeatureModule,
    OrganizationUserRegistrationFeatureModule,
    OrganizationAdministrationFeatureModule,
    OrganizationAccountSummaryFeatureModule,
    OrganizationUnitOrderFeatureModule,
    OrganizationOrderApprovalFeatureModule,
    StoreFinderFeatureModule,
    AsmFeatureModule,
    AsmCustomer360FeatureModule,
    SmartEditFeatureModule,
    ProductMultiDimensionalSelectorFeatureModule,
    ProductVariantsFeatureModule,
    ProductImageZoomFeatureModule,
    QuoteFeatureModule,

  ],
  providers: [provideFeatureToggles({
    "showDeliveryOptionsTranslation": false,
    "formErrorsDescriptiveMessages": false,
    "showSearchingCustomerByOrderInASM": false,
    "showStyleChangesInASM": false,
    "shouldHideAddToCartForUnpurchasableProducts": false,
    "useExtractedBillingAddressComponent": false,
    "showBillingAddressInDigitalPayments": false,
    "showDownloadProposalButton": false,
    "showPromotionsInPDP": false,
    "searchBoxV2": false,
    "recentSearches": false,
    "trendingSearches": false,
    "pdfInvoicesSortByInvoiceDate": false,
    "storeFrontLibCardParagraphTruncated": false,
    "useProductCarouselBatchApi": false,
    "productConfiguratorAttributeTypesV2": false,
    "propagateErrorsToServer": false,
    "ssrStrictErrorHandlingForHttpAndNgrx": false,
    "productConfiguratorDeltaRendering": false,
    "a11yRequiredAsterisks": false,
    "a11yQuantityOrderTabbing": false,
    "a11yNavigationUiKeyboardControls": false,
    "a11yNavMenuExpandStateReadout": false,
    "a11yOrderConfirmationHeadingOrder": false,
    "a11yStarRating": false,
    "a11yViewChangeAssistiveMessage": false,
    "a11yPreventHorizontalScroll": false,
    "a11yReorderDialog": false,
    "a11yPopoverFocus": false,
    "a11yScheduleReplenishment": false,
    "a11yScrollToTop": false,
    "a11ySavedCartsZoom": false,
    "a11ySortingOptionsTruncation": false,
    "a11yExpandedFocusIndicator": false,
    "a11yCheckoutDeliveryFocus": true,
    "a11yMobileVisibleFocus": false,
    "a11yOrganizationsBanner": false,
    "a11yOrganizationListHeadingOrder": false,
    "a11yCartImportConfirmationMessage": false,
    "a11yReplenishmentOrderFieldset": false,
    "a11yListOversizedFocus": false,
    "a11yStoreFinderOverflow": false,
    "a11yMobileFocusOnFirstNavigationItem": false,
    "a11yCartSummaryHeadingOrder": false,
    "a11ySearchBoxMobileFocus": false,
    "a11yFacetKeyboardNavigation": false,
    "a11yUnitsListKeyboardControls": false,
    "a11yCartItemsLinksStyles": false,
    "a11ySearchboxLabel": false,
    "a11yHideSelectBtnForSelectedAddrOrPayment": false,
    "a11yFocusableCarouselControls": false,
    "a11yUseTrapTabInsteadOfTrapInDialogs": false,
    "cmsGuardsServiceUseGuardsComposer": false,
    "cartQuickOrderRemoveListeningToFailEvent": false,
    "a11yKeyboardAccessibleZoom": false,
    "a11yOrganizationLinkableCells": false,
    "a11yVisibleFocusOverflows": false,
    "a11yTruncatedTextForResponsiveView": false,
    "a11ySemanticPaginationLabel": false,
    "a11yPreventCartItemsFormRedundantRecreation": false,
    "a11yPreventSRFocusOnHiddenElements": false,
    "a11yMyAccountLinkOutline": false,
    "a11yCloseProductImageBtnFocus": false,
    "a11yNotificationPreferenceFieldset": false,
    "a11yImproveContrast": false,
    "a11yEmptyWishlistHeading": false,
    "a11yScreenReaderBloatFix": false,
    "a11yUseButtonsForBtnLinks": false,
    "a11yTabComponent": false,
    "a11yCarouselArrowKeysNavigation": false,
    "a11yPickupOptionsTabs": false,
    "a11yNotificationsOnConsentChange": false,
    "a11yDisabledCouponAndQuickOrderActionButtonsInsteadOfRequiredFields": false,
    "a11yFacetsDialogFocusHandling": false,
    "headerLayoutForSmallerViewports": false,
    "a11yStoreFinderAlerts": false,
    "a11yFormErrorMuteIcon": false,
    "a11yCxMessageFocus": false,
    "a11yLinkBtnsToTertiaryBtns": false,
    "a11yRepeatedPageTitleFix": false,
    "a11yDeliveryModeRadiogroup": true,
    "a11yNgSelectOptionsCount": false,
    "a11yRepeatedCancelOrderError": false,
    "a11yAddedToCartActiveDialog": false,
    "a11yNgSelectMobileReadout": false,
    "a11yDeliveryMethodFieldset": false,
    "a11yShowMoreReviewsBtnFocus": false,
    "a11yQuickOrderAriaControls": false,
    "a11yRemoveStatusLoadedRole": false,
    "a11yDialogsHeading": false,
    "a11yDialogTriggerRefocus": false,
    "a11yAddToWishlistFocus": false,
    "a11ySearchBoxFocusOnEscape": false,
    "a11yUpdatingCartNoNarration": false,
    "a11yPasswordVisibliltyBtnValueOverflow": false,
    "a11yItemCounterFocus": false,
    "a11yScrollToReviewByShowReview": false,
    "a11yViewHoursButtonIconContrast": false,
    "a11yCheckoutStepsLandmarks": false,
    "a11yQTY2Quantity": false,
    "a11yDeleteButton2First": false,
    "occCartNameAndDescriptionInHttpRequestBody": false,
    "cmsBottomHeaderSlotUsingFlexStyles": false,
    "useSiteThemeService": false,
    "enableConsecutiveCharactersPasswordRequirement": false,
    "enablePasswordsCannotMatchInPasswordUpdateForm": false,
    "allPageMetaResolversEnabledInCsr": false,
    "useExtendedMediaComponentConfiguration": false
  })]
})
export class SpartacusFeaturesModule { }
